export default __webpack_public_path__ + "hourglass.483b02d.png";